import { drawBooleanOption } from "./drawBooleanOption";
import { drawSliderOption } from "./drawSwitchOption";
export const drawOption = (parent, option) => {
    if (option.type === "slider") {
        drawSliderOption(parent, option);
    }
    else {
        drawBooleanOption(parent, option);
    }
};
